import {
  CarReservationDetailTitle,
  CarReservationConfirmation,
  CarReservationDetailSummary,
  CarReservationSelfServeLinks,
} from "@apac/components/cars";
import { MyTripPageHeader } from "@apac/components/ui";
import { useModuleBEM } from "@b2bportal/core-themes";
import type { Itinerary } from "@b2bportal/ground-api";
import { Card } from "@tenant/ui";
import defaultStyles from "./CarReservationDetails.module.scss";
import {
  CarReservationPolicies,
  CarReservationCheckoutBreakdown,
} from "@/modules/cars-postbooking/components";

export interface CarReservationDetailsProps {
  itinerary: Itinerary;
  onCancel: () => void;
}

const ComponentName = "CarReservationDetails";

export const CarReservationDetails = ({
  itinerary,
  onCancel,
}: CarReservationDetailsProps) => {
  const [block, cn] = useModuleBEM(defaultStyles, ComponentName);
  return (
    <div className={block}>
      <MyTripPageHeader className={cn("header")} />

      <Card className={cn("title")}>
        <CarReservationDetailTitle reservation={itinerary.reservation} />
      </Card>

      <div className={cn("two-column")}>
        <div className={cn("left-column")}>
          <CarReservationDetailSummary
            className={cn("car-details")}
            reservation={itinerary.reservation}
          />

          <Card className={cn("self-serve", ["mobile"])}>
            <CarReservationSelfServeLinks
              reservation={itinerary}
              onCancel={onCancel}
            />
          </Card>

          <Card className={cn("booking-details")}>
            <CarReservationConfirmation reservation={itinerary.reservation} />
          </Card>

          {/* TODO(RBC-844): Add Rewards Section
                          <Card className={cn("rewards")}>
                          </Card> */}

          <Card className={cn("policies")}>
            <CarReservationPolicies
              reservation={itinerary.reservation}
              onCancel={onCancel}
            />
          </Card>

          <Card className={cn("price-breakdown")}>
            <CarReservationCheckoutBreakdown itinerary={itinerary} />
          </Card>
        </div>

        <div className={cn("right-column")}>
          <Card className={cn("self-serve", ["desktop"])}>
            <CarReservationSelfServeLinks
              reservation={itinerary}
              onCancel={onCancel}
            />
          </Card>
        </div>
      </div>
    </div>
  );
};
